import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import TransitionedBlock from "../../HelperComponents/TransitionedBlock/TransitionedBlock";
import ShopPageCard from "../../ShopPage/ShopPageCard";
import Pagination from "../../HelperComponents/Pagination/Pagination";

import { getStorages, makeRequest, getRelatedProducts } from "../../../actions/productsActions";

import "./BuyTogether.scss";

const PAGE_SIZE = 12;

const getSlugFromUrl = () => {
    const pathParts = window.location.pathname.split('/').filter(part => part);
    return pathParts[pathParts.length - 1];
};


const BuyTogether = ({ history, location }) => {
    const dispatch = useDispatch();
    const relatedProducts = useSelector((state) => state.products.related_products);
    const activePage = parseInt(new URLSearchParams(location.search).get("page")) || 1;
    const slug = getSlugFromUrl();
    useEffect(() => {
        if (slug) {
            dispatch(getRelatedProducts(slug, activePage, PAGE_SIZE));
        }
    }, [dispatch, slug, activePage]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("page") && params.get("page") !== "1") {
            params.set("page", 1);
            history.push({ search: params.toString() });
        }
    }, [slug, history]);

    const handleGetStorages = useCallback((...args) => {
        dispatch(getStorages(...args));
    }, [dispatch]);

    const handleMakeRequest = useCallback((...args) => {
        dispatch(makeRequest(...args));
    }, [dispatch]);

    const handlePageChange = ({ selected }) => {
        // Pagination component handles the URL update
    };

    const hasProducts = relatedProducts && relatedProducts.results && relatedProducts.results.length > 0;

    return (
        <TransitionedBlock classes="transitioned_block">
            <div className="buy_together_wrapper">
                <div className="buy_together">
                    {hasProducts ? (
                        relatedProducts.results.map((el, idx) => {
                            const sum = el.storage_quantity.reduce(
                                (total, item) => total + (item.quantity || 0),
                                0
                            );
                            const productUrl = `/main/shop/product/${el.slug}`;

                            return (
                                <ShopPageCard
                                    key={el.id || idx}
                                    el={el}
                                    idx={idx}
                                    sum={sum}
                                    productUrl={productUrl}
                                    getStorages={handleGetStorages}
                                    productsStoragesName={"products_results"}
                                    makeRequest={handleMakeRequest}
                                />
                            );
                        })
                    ) : (
                        <p>Товаров нет</p>
                    )}


                </div>
                {hasProducts && relatedProducts.count > PAGE_SIZE && (
                    <Pagination
                        pageCount={Math.ceil(relatedProducts.count / PAGE_SIZE)}
                        onPageChange={handlePageChange}
                        forcePage={activePage - 1}
                    />
                )}   </div>
        </TransitionedBlock>
    );
};

export default withRouter(BuyTogether);